export const FILE_TYPE_SETTINGS_TITLE_ID = 'file-type-settings-title';
export const FILE_TYPE_DESCRIPTION_ID = 'file-type-settings-description';

export const FILE_TYPE_OPTION = {
	HTML: 'html',
	PDF: 'pdf'
} as const;

export type FileTypeOption = (typeof FILE_TYPE_OPTION)[keyof typeof FILE_TYPE_OPTION];

export const RADIO_OPTIONS_CONFIG = [
	{ label: 'HTML', value: FILE_TYPE_OPTION.HTML },
	{ label: 'PDF', value: FILE_TYPE_OPTION.PDF }
] as const;
